import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_ClassAttendanceVerification {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadClassAttendance(PARMSLIST) {
		var postResult$ = new Subject();
		var url = "Section/LoadClassAttendance?" + "FORMATTEDPARMS";

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
